import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "home", to: "#home", isSection: true },
  { name: "skills", to: "#skills", isSection: true },
  { name: "projects", to: "#projects", isSection: true },
  { name: "experience", to: "#experience", isSection: true },
  { name: "contact", to: "#contact", isSection: true },
  { name: "timeline", to: "/timeline" },
  {
    name: "resume",
    to: "https://drive.google.com/file/d/1PqsuF-5bD_kDCmMkU62Xa4bgCybv3OoD/view?usp=sharing",
    external: true,
  },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Smooth scroll to section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    closeMenu();
  };

  // Handle navigation click
  const handleNavClick = (link, e) => {
    if (link.isSection) {
      e.preventDefault();
      const sectionId = link.to.replace("#", "");

      // If we're not on the home page, navigate there first
      if (location.pathname !== "/") {
        window.location.href = `/${link.to}`;
      } else {
        scrollToSection(sectionId);
      }
    } else if (link.external) {
      closeMenu();
    } else {
      closeMenu();
    }
  };

  return (
    <>
      {/* Hamburger Button */}
      <button
        onClick={toggleMenu}
        className="fixed top-5 right-5 sm:top-8 sm:right-8 md:top-10 md:right-10 w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-white rounded-full shadow-lg z-50 flex flex-col items-center justify-center space-y-1 hover:scale-105 transition-transform duration-200"
        aria-label="Toggle menu"
      >
        <span
          className={`block h-0.5 w-6 sm:w-7 md:w-8 bg-[#FFCD29] transition-all duration-300 ${
            isOpen ? "rotate-45 translate-y-1.5" : ""
          }`}
        ></span>
        <span
          className={`block h-0.5 w-6 sm:w-7 md:w-8 bg-[#FFCD29] transition-all duration-300 ${
            isOpen ? "opacity-0" : ""
          }`}
        ></span>
        <span
          className={`block h-0.5 w-6 sm:w-7 md:w-8 bg-[#FFCD29] transition-all duration-300 ${
            isOpen ? "-rotate-45 -translate-y-1.5" : ""
          }`}
        ></span>
      </button>

      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black transition-opacity duration-300 z-40 ${
          isOpen ? "opacity-60" : "opacity-0 pointer-events-none"
        }`}
        onClick={closeMenu}
      />

      {/* Navigation Menu */}
      <nav
        className={`fixed inset-0 bg-white z-40 flex items-center justify-center transition-transform duration-300 ${
          isOpen ? "transform translate-x-0" : "transform translate-x-full"
        }`}
      >
        <ul className="flex flex-col items-center space-y-6 sm:space-y-8 text-center max-h-screen overflow-y-auto py-8">
          {navLinks.map((link) => {
            if (link.external) {
              return (
                <li key={link.name}>
                  <a
                    href={link.to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light text-[#080808] hover:text-[#FFCD29] transition-colors duration-300 tracking-wide"
                    onClick={(e) => handleNavClick(link, e)}
                  >
                    {link.name}
                  </a>
                </li>
              );
            } else if (link.isSection) {
              return (
                <li key={link.name}>
                  <button
                    onClick={(e) => handleNavClick(link, e)}
                    className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light text-[#080808] hover:text-[#FFCD29] transition-colors duration-300 tracking-wide"
                  >
                    {link.name}
                  </button>
                </li>
              );
            } else {
              return (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light text-[#080808] hover:text-[#FFCD29] transition-colors duration-300 tracking-wide"
                    onClick={(e) => handleNavClick(link, e)}
                  >
                    {link.name}
                  </Link>
                </li>
              );
            }
          })}
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
